import { AnyObject } from "shared/types/common";

export const numberInputConfig: AnyObject<string> = {
  money: " ₽",
  percentage: " %",
};
